// Single source of truth for payment-method values on the frontend.
// Mirrors the set the backend accepts in BillingService::recordPayment
// ($allowed = ['cash','transfer','card','stripe','other']) — keep in sync.

import { t } from './i18n.js';

// Every method the backend may store (used for labelling history rows).
export const PAYMENT_METHODS = ['cash', 'transfer', 'card', 'stripe', 'other'];

// Methods offered when a landlord *manually* records a payment. 'stripe' is an
// automated online method, so it's labelled in history but not a manual choice.
// 'transfer' leads as the common default.
export const MANUAL_PAYMENT_METHODS = ['transfer', 'cash', 'card', 'other'];

// Localized label for a stored method; unknown/legacy values fall back to the
// raw string so unexpected data still renders something sensible.
export function paymentMethodLabel(method) {
  return PAYMENT_METHODS.includes(method) ? t('dashboard.rent.method.' + method) : (method || '');
}
